import {
  PRODUCT_FILTERS_INIT,
  PRODUCT_FILTERS_SEARCH,
  PRODUCT_FILTERS_SET_FILTERS,
  PRODUCT_FILTERS_ORDER,
  PRODUCT_FILTERS_ORDER_FIELD,
} from '../constants/productFiltersTypes';

import { PERMISSIONS_TAB } from '../constants/permissionsTypes';

const initialState = {
  filters: {},
  currentFilters: {},
  currentFilterSearches: {},
  order: 'asc',
  orderField: 'title',
};

const productFilters = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_FILTERS_INIT:
      const currentFilterSearches = Object.keys(action.payload).reduce((acc, key) => {
        acc[key] = '';
        return acc;
      }, {});

      return {
        ...state,
        filters: action.payload,
        currentFilterSearches,
      };

    case PRODUCT_FILTERS_SEARCH:
      const { filter, value } = action.payload;

      return {
        ...state,
        currentFilterSearches: {
          ...state.currentFilterSearches,
          [filter]: value,
        },
      };

    case PRODUCT_FILTERS_SET_FILTERS:
      return {
        ...state,
        currentFilters: action.payload,
      };

    case PRODUCT_FILTERS_ORDER:
      return {
        ...state,
        order: action.payload,
      };

    case PRODUCT_FILTERS_ORDER_FIELD:
      return {
        ...state,
        orderField: action.payload,
      };

    case PERMISSIONS_TAB:
      return {
        ...state,
        currentFilters: {},
      };
    default:
      break;
  }

  return state;
};

export default productFilters;
